import { render, staticRenderFns } from "./AssignUserTags.vue?vue&type=template&id=f6a948a0&scoped=true"
import script from "./AssignUserTags.vue?vue&type=script&lang=js"
export * from "./AssignUserTags.vue?vue&type=script&lang=js"
import style0 from "./AssignUserTags.vue?vue&type=style&index=0&id=f6a948a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a948a0",
  null
  
)

export default component.exports